$(document).ready(function() { 
  $('body').on('change','.for-desk-only input[type=radio][name=selling_plan]',function(){
    $('.quantity-box.only-product').each(function(){
      $(this).find('input').removeAttr("name");
    });
    if($(this).is(':checked')) {
      $(this).parents('.appstle_subscription_wrapper_option').find('.quantity-box.only-product').find('input').attr("name","quantity");
    }
     $('.for-desk-only').find('.appstle_subscribe_save_text').find('.appstle_tooltip_wrapper').remove();
    var tooltip_desk = $('.for-desk-only').find('.appstle_tooltip_wrapper').clone();
    $('.for-desk-only').find('.appstle_subscribe_save_text').append(tooltip_desk);
  });

  $('body').on('change','.for-mobile-only input[type=radio][name=selling_plan]',function(){
    $('.quantity-box.only-product').each(function(){
      $(this).find('input').removeAttr("name");
    });
    if($(this).is(':checked')) {
      $(this).parents('.appstle_subscription_wrapper_option').find('.quantity-box.only-product').find('input').attr("name","quantity");
    }
    $('.for-mobile-only').find('.appstle_subscribe_save_text').find('.appstle_tooltip_wrapper').remove();
    var tooltip_mob = $('.for-mobile-only').find('.appstle_tooltip_wrapper').clone();
    $('.for-mobile-only').find('.appstle_subscribe_save_text').append(tooltip_mob);
  });

  $('body').on('change','.for-mobile-only .appstle_select',function(){
    $('.for-mobile-only').find('.appstle_subscribe_save_text').find('.appstle_tooltip_wrapper').remove();
    var tooltip_mob = $('.for-mobile-only').find('.appstle_tooltip_wrapper').clone();
    $('.for-mobile-only').find('.appstle_subscribe_save_text').append(tooltip_mob);
  });


  $('body').on('change','.for-desk-only .appstle_select',function(){
    $('.for-desk-only').find('.appstle_subscribe_save_text').find('.appstle_tooltip_wrapper').remove();
    var tooltip_desk = $('.for-desk-only').find('.appstle_tooltip_wrapper').clone();
    $('.for-desk-only').find('.appstle_subscribe_save_text').append(tooltip_desk);
  });
  
  /*ADDED BY LR*/
  $('.wmb-slider-main').slick(
    {
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: true,
      autoplay: true,
  	  autoplaySpeed: 5000,
      speed: 500,
      responsive : [
      	{
                breakpoint: 768,
                settings: {
                    arrows:false
                }
            }
      ]
    });
  
   $('.cookie-slider').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    centerMode: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows:true
                }
            } ,
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:true
                }
            }
        ]
   }); 
    $('.customer-review-slider').slick({
        dots: true,
        infinite: true,
        arrows: true,
        speed: 300,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{ 
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1, 
                }
            } ,
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    }); 
    $('.moravian-content-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{ 
                breakpoint:1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1, 
                }
            } ,
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1, 
                }
            }
        ]
    }); 
  $('.meet-family-slider').slick({
    	slidesToShow:1,
		slidesToScroll: 1, 
        arrows: true,
    	autoplay:true,
    	speed: 800,
        dots: false 
    });  
    $('.cookie-slider-mbl').slick({
    	slidesToShow:1,
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick'
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2 
                }
            }
        ]
    });  
    $('.pdp-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        centerMode: false,
        slidesToShow: 2, 
        slidesToScroll: 1,
        responsive: [{ 
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1, 
                }
            } ,
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    }); 
  
  
  $('.news-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1 
  }); 
  
  /********* mini cart ********/
  $('.cart-opener').on('click',function(e){
    e.preventDefault();
    jQuery('body').addClass('cartOpen');
    jQuery(".closecart").focus();
  });

  $('body').on('click','.closecart', function(e){
    e.preventDefault();
    jQuery('body').removeClass('cartOpen');
  });
  
  $('.cart-overlay').on('click', function(e){
    e.preventDefault();
    jQuery('body').removeClass('cartOpen');
  });
  function addToCartSuccess() {
    $.get( "/cart?view=mini-cart", function( data ) {
      $('#crtwrap').html(data);
      $('#crtwrap').removeClass('loading');
    });
  }
  function addToCartSuccess_cart() {
    $.get( "/cart?view=cart-full", function( data ) {
      $('#cart-data').html(data);
    });
  }
  function refreshCart(count) {
    $.getJSON('/cart.js', function(cart){
      $('.cart-count').text(cart.item_count);
    });
  }

  $('body').on('click','#add-to-cart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    form.find('.error').remove();
    btn.attr('disabled', 'disabled');
    btn.text('Added');
    form.find('.error').remove();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('Add to Cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('Add to Cart');
      btn.removeAttr('disabled');
      refreshCart();
      $('body').addClass('cartOpen');
    });

  });


  $('body').on('click', '.qtyAdjust .adjust',function(e){
    e.preventDefault();
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);
    
    
    var updatedPrice = $(document).find('.product-price');
    consoe.log( updatedPrice ); 
//     $(document).find('.total-price').text( updatedPrice ); 

    $('#crtwrap').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crtwrap').removeClass('loading');
      },
      success: function(){
        addToCartSuccess();
        refreshCart();
        $('#crtwrap').removeClass('loading');
      }
    });

  });
  
  $('body').on('click', '.qtty .adjust',function(e){
    e.preventDefault();
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function(){
        addToCartSuccess_cart();
        refreshCart();
      }
    });

  });
  
  $("#crtwrap").on('click', "a.remove_item", function(r){
    $('#crtwrap').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      addToCartSuccess();
      refreshCart();
    });
  });
  
  $("body").on('click', "a.cart__remove", function(r){
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      addToCartSuccess_cart();
      refreshCart();
    });
  });
   $("body").on("click",".apply_discount",function(e){
    $('.checkout-link').trigger('click');
  });
    /********* Mobile Menu ********/
    jQuery(".mobile-menu").click(function() {
        jQuery(".mobile-menu-button").toggleClass("on");
        jQuery(".mobile-navbar").toggleClass("active");
        jQuery("header").toggleClass("menu-active");
        jQuery("body").toggleClass("no-scroll");
    });
    jQuery(".close-menu").click(function() {
        jQuery(".mobile-menu-button").removeClass("on");
        jQuery(".mobile-navbar").removeClass("active");
        jQuery("header").removeClass("menu-active");
        jQuery("body").removeClass("no-scroll");
    }); 
  /************* FIXED HEADER JS *************/
   if($('.fixed-header-inner').length > 0){
      var header_hright = $('.fixed-header-inner').outerHeight();  
      $('.wrapper').css('margin-top',header_hright+'px');
    }
  	/********* Video play btn **********/ 
   
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }
  function playpauseiframe(overlay_popup){
    var command,slideType,player,control,video;
    slideType = overlay_popup.find(".videotype").attr("class").split(" ")[0];

    player = overlay_popup.find("iframe").get(0);
    if(overlay_popup.find("iframe").hasClass('playiframe')){
      control='play';
    }else{
      control='pause';
    }
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
         
          if (!overlay_popup.hasClass('started')) {
            overlay_popup.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : ''
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          
          overlay_popup.find("iframe").removeClass("playiframe");
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          overlay_popup.find("iframe").addClass("playiframe"); 
          break;
      }
    } else if (slideType === "video") {
      video = overlay_popup.find("video").get(0);
      if (video != null) {
        if (video.paused){
          video.play();
        } else {
          video.pause();
        }
      }
    }

  }
  
  jQuery('.close_popup').click(function (m) { 
    var overlay_popup = $(this).parents('.overlay_popup');
    overlay_popup.removeClass('popup_show');
  });
  

  var youtube_first = 1;
  $('.video_button_vimeo,.video_button_video').on('click', function(ev) {
    var index = $(this).data("index");
    var overlay_popup;
    overlay_popup = $('.overlay_popup.custom_popup_show_'+index);
    jQuery('body,html').toggleClass('scollno').toggleClass('popupopen');
    overlay_popup.toggleClass('popup_show');
    var index = $(this).data("index");
    var video = $(this).data("video");
    overlay_popup.find(".videoFrame").addClass('playiframe');
//     overlay_popup.find(".videoFrame")[0].src += "&autoplay=1";
    playpauseiframe(overlay_popup);

    ev.preventDefault();
  });

  jQuery('.close_popup').click(function (m) {   
    var index = $(this).data("index");
      var overlay_popup = $('.overlay_popup.custom_popup_show_'+index);
      $('.overlay_popup').removeClass('popup_show');
      playpauseiframe(overlay_popup);
  });     
  

    /******* Accordian JS *******/
    function close_accordion_section() {
        jQuery('.accordion .accordion-section-title').removeClass('active');
        jQuery('.accordion .accordion-section-content').slideUp(300).removeClass('open');
    } 
    jQuery('.accordion-section-title').click(function (e) {
        // Grab current anchor value
        var currentAttrValue = jQuery(this).attr('href');

        if (jQuery(e.target).is('.active')) {
            close_accordion_section();
        } else {
            close_accordion_section();

            // Add active class to section title
            jQuery(this).addClass('active');
            // Open up the hidden content panel
            jQuery('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
        }
        e.preventDefault();
    });   
    /* Header ACCOUNT TABS ENDS*/ 
    /*window scroll class add to header start here*/
    jQuery(window).scroll(function(){
        jQuery(this).scrollTop()>50?
        jQuery("header").addClass("fix-header"):$("header").removeClass("fix-header")
    });
    /*window scroll class add to header end here*/ 
    /********* Cart / Footage Calc - Popup functions ********/
    function closepop(){
        //     lockBodyScroll(false);
        $(".mini-cart").removeClass("active"); 
        $('body').removeClass("active");
        $(".overlay").removeClass("active");
    }
    function openpop(){
        //     lockBodyScroll(true);
        $(".mini-cart").addClass("active"); 
        $('body').addClass("active");  
        $(".overlay").addClass("active");
    }
    $("body").on('click', ".cart-opener", function(e){
        e.preventDefault();
        openpop();
    });
    $("body").on('click', ".close-icon-wrap", function(e){
        e.preventDefault();
        closepop();
    });
    $("body").on('click', ".overlay", function(e){
        e.preventDefault();
        closepop();
    }); 
 
  
     AOS.init(); 
    /**
     * Detect OS & browsers
     */
    /* Add class for mac */
    if(navigator.appVersion.indexOf("Win")!=-1) {
        jQuery('body').addClass('window-os');
    }
    if(navigator.platform.toUpperCase().indexOf('MAC')>=0) {
        jQuery('body').addClass('mac-os');
    }
    if(navigator.appVersion.indexOf("Linux")!=-1) {
        jQuery('body').addClass('linux-os');
    }
    /* Add class for all ie version */
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var net = !!navigator.userAgent.match(/.NET4.0E/);
    var IE11 = trident && net;
    var IEold = ( navigator.userAgent.match(/MSIE/i) ? true : false );
    if(IE11 || IEold){
        jQuery('body').addClass('ie');
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
        jQuery('body').addClass('chrome');
        } else {
        jQuery('body').addClass('safari');
        }
    }
    var FF = !(window.mozInnerScreenX == null);
    if(FF) {
        jQuery('body').addClass('fire-fox'); 
    } else { 
        //jQuery('body').addClass('not-fire-fox');
    }
    /* End */
 /******** PRODUCT PAGE TOGGLE JS Ends********/ 
    $(".set > h4").on("click", function () { 
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".content") .slideUp(200); 
        } 
        else { 
            $(".set > h4").removeClass("active");
            $(this).addClass("active");
            $(".content").slideUp(200);
            $(this).siblings(".content").slideDown(200);
        }
    }); 
  

  
  $('.palceholder').click(function() {
    $(this).siblings('input').focus();
  });
  $('.form-control').focus(function() {
    $(this).siblings('.palceholder').hide();
  });
  $('.form-control').blur(function() {
    var $this = $(this);
    if ($this.val().length == 0)
      $(this).siblings('.palceholder').show();
  });
  $('.form-control').blur();


  $('body').on('click','.contact_send', function(e){
    var form = $(this).closest('.contact_form');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var phone_no =  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    var x = true;
    form.find('.err_msg').remove();

    var name = form.find('#Name');
    var msg = form.find('#Message');
    var email = form.find('#Email');
    var phone = form.find('#Phone');


    if(name.val().trim() == ''){
      var message = "Enter your name.";
      name.parent().append('<p class="err_msg">'+message+'</p>');
      x = false;
    } else {
      name.parent().find('.err_msg').remove();
    }


    if(msg.val().trim() == ''){
      var message = "Enter your your message.";
      msg.parent().append('<p class="err_msg">'+message+'</p>');
      x = false;
    } else {
      msg.parent().find('.err_msg').remove();
    }

    if(email.val().trim() == '' || !regex.test(email.val())) {
      var message = "Please enter valid email";
      if(email.val() == ''){
        message = "Enter your email.";
      }
      email.parent().append('<p class="err_msg">'+message+'</p>');
      x = false;
      e.preventDefault();
    } else {
      email.parent().find('.err_msg').remove();
    }

    if(phone.val().trim() == '' || !phone_no.test(phone.val())) {
      var message = "Please enter valid Phone No..";
      if(phone.val() == ''){
        message = "Enter your phone number.";
      }
      phone.parent().append('<p class="err_msg">'+message+'</p>');
      x = false;
      e.preventDefault();
    } else {
      phone.parent().find('.err_msg').remove();
    }


    if(x==false) {
      return false;
    }
  });

// store locator js
  $('.store_loctor_icon').on('click',function(e){
    e.preventDefault();
    if($(window).width() < 992 ){
      console.log('clicked')
      $(".mobile-menu-button").toggleClass("on");
      $(".mobile-navbar").toggleClass("active");
      $("header").toggleClass("menu-active");
      $("body").toggleClass("no-scroll");
    }
    console.log('clicked..')
    var h = $('header').height();
  	$('html, body').animate({
        scrollTop: $(".footer-middle-new-row").offset().top - h
    }, 2000);
  });

//   instagram js
  $.getJSON('https://ifa.cirkleinc.com/insta-feed-fronted?shop=moravian-bakery.myshopify.com&gallery_type=homeGallery&pageno=1&product_handle=',function(data){
    $('.insta__img').each(function(i){
      if(i<=2){
        if(data.data[i].media_url.indexOf('video') != -1){
          $(this).find('.insta-col-img').append("<a class='insta_hover' href='"+data.data[i].permalink+"' target='_blank'><video loop='' muted='' width='100%' controls='' itemprop='thumbnail' class='img-thumbnail img-fluid' ><source src="+data.data[i].media_url+" type='video/mp4'>Your browser does not support HTML5 video.</video><div class='svg_txt'><p class='insta_ssvg'><svg height='32px' viewBox='0 0 511 511.9' width='32px' xmlns='http://www.w3.org/2000/svg'><path d='m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0'></path><path d='m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0'></path><path d='m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0'></path></svg></p><p class='insta_txt'>Shop on Instagram</p></div></a>");
        }else{
          $(this).find('.insta-col-img').append("<a class='insta_hover' href='"+data.data[i].permalink+"' target='_blank'><img src="+data.data[i].media_url+"><div class='svg_txt'><p class='insta_ssvg'><svg height='32px' viewBox='0 0 511 511.9' width='32px' xmlns='http://www.w3.org/2000/svg'><path d='m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0'></path><path d='m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0'></path><path d='m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0'></path></svg></p><p class='insta_txt'>Shop on Instagram</p></div></a>");
        }
      }
    });
  });    
  if($(window).width() < 992)
    {
       var maxheight = $('.cart-page-right').height();
      $('.leffft .cart-page-left').css({"max-height": maxheight + "px"});

      $("body").click(function(){
        setTimeout(function(){ 
          var cickmaxheightcl = $('.cart-page-right').height();
          $('.leffft .cart-page-left').css({"max-height": cickmaxheightcl + "px"});
        }, 100);
      });  
    }  
  $(".faq-left-bar a").on('click', function(event) {
    event.preventDefault()
    var headerHeight = $('header').height();
    var Total = headerHeight + 30;
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - Total,
    }, 'linear');
  });
//  FAQ 
  var urllink = window.location.href;
  var urllink1 = '/faq/#wmb-fam-subscriptions';
  if( urllink.includes('#')){
    urllink = urllink.split('#');
    // Handler for .ready() called.
    var height = $('header').height();
    $('html, body').animate({
      scrollTop: $('#'+urllink[1]).offset().top - height
    }, 'slow');
  }
  if(urllink.includes('wmb-fam-subscriptions')){
    console.log('Innnn');
    $('a[href="/pages/faq/#wmb-fam-subscriptions"]').on('click', function(e){
      e.preventDefault();
      console.log('aa');
      var height = $('header').height();
      $('html, body').animate({
        scrollTop: $('#wmb-fam-subscriptions').offset().top - height
      }, 'slow');
    });
  }
});
// window.addEventListener("load", function(){
//   $(window).on('load resize ', function() {
//     var sliderheight = $('.pdp-page-banner').height();
//     var headerheight = $('.fixed-header-inner').height();
//     var boxheight = $('.cookie-box').height();
//     var topspacing = ((sliderheight - boxheight  ) / 2 + headerheight);
//     $('.cookie-box').css("top", topspacing);
//     console.log( `slider ${sliderheight}`);
//     console.log(`box ${boxheight}`);
//   });
// });
// window.addEventListener("load", function(){
  
// });

 


 
// document.addEventListener('DOMContentLoaded', function() {
//    // your code here
//   loadtop('aaa');
// }, false);
// $(document).ready(function(){
// 	loadtop('dd');
// });

// window.onload = function() {
//     hitesh();
// };
// function loadfun()
// {
//     var sliderheight = $('.pdp-page-banner').height();
//     var boxheight = $('.cookie-box').height();
//     var topspacing = ((sliderheight - boxheight) / 2 + 154);
//     $('.cookie-box').css("top", topspacing);
// }
// $(window).on('load', function() {
// 		loadfun();
// });
   
$(window).on('load', function() {
  function find_subscription_wrapper(){
    if($('.appstle_subscription_wrapper').length){
     
      var objDesctope = $('.for-desk-only').find('.quantity-box.only-product').detach().get(0);
      $('.for-desk-only').find('.appstle_subscription_wrapper_option').append(objDesctope);
      var objmobctope = $('.for-mobile-only').find('.quantity-box.only-product').detach().get(0);
      $('.for-mobile-only').find('.appstle_subscription_wrapper_option').append(objmobctope);
      $('.for-desk-only').find('.appstle_subscribe_save_text').find('.appstle_tooltip_wrapper').remove();
      $('.for-mobile-only').find('.appstle_subscribe_save_text').find('.appstle_tooltip_wrapper').remove();
      var tooltip_desk = $('.for-desk-only').find('.appstle_tooltip_wrapper').clone();
      $('.for-desk-only').find('.appstle_subscribe_save_text').append(tooltip_desk);
      var tooltip_mob = $('.for-mobile-only').find('.appstle_tooltip_wrapper').clone();
      $('.for-mobile-only').find('.appstle_subscribe_save_text').append(tooltip_mob);

      
      $('.quantity-box.only-product').each(function(){
        $(this).find('input').removeAttr("name");
        if ($(window).width() > 991) {
          $('.for-desk-only').find('.appstle_subscription_wrapper_option.appstle_selected_background').find('.item-quantity').attr('name','quantity');
        }else{
          $('.for-mobile-only').find('.appstle_subscription_wrapper_option.appstle_selected_background').find('.item-quantity').attr('name','quantity');
        }
      });

    }else{
      setTimeout(function(){
        find_subscription_wrapper();
      },1000);
    }
  }
  find_subscription_wrapper();
});
$(window).on('load resize scroll', function() {

//   if (window.matchMedia('(min-width: 1615px)').matches) {
//     var wid = window.innerWidth;
//     var sliderpadding = (wid - 1415) / 2;
//     var sliderItem = $('.pdp-slider-item img').innerWidth();
//     $(".pdp-page-banner .slick-list").css("padding-left", sliderpadding - 6);
//     $(".pdp-page-banner .slick-list").css("padding-right", sliderpadding - 6);
//     $(".cookie-box").css("margin-right", sliderpadding);
//     $(".pdp-slider.arrow-long .slick-prev").css("left", sliderpadding - 65);

//   } 
//   else {
//     $(".pdp-page-banner .slick-list").removeAttr("style");
//      $(".cookie-box").removeAttr("style");
//      $(".pdp-slider.arrow-long .slick-prev").removeAttr("style");
//   }
//   else if(window.matchMedia('(min-width: 992px)').matches){
//     var wid = window.innerWidth;
//     var sliderpadding = (wid - 1415) / 2;
//     $(".pdp-page-banner .slick-list").css("padding-left", 20);
//     $(".pdp-page-banner .slick-list").css("padding-right", 20);
//     $(".cookie-box").css("margin-right", 20);
//     $(".pdp-slider.arrow-long .slick-prev").css("left", 30);
//   }
});
$(window).on('resize', function() {
    $('.cookie-slider-mbl').slick('resize');
});
// window.addEventListener('load', (event) => {
// //   console.log('page is fully loaded');
  
// });

$(window).on('load', function() {
    if(jQuery(window).width() > 991) {
        var cookieheight = $(".cookie-box").outerHeight() + 148;   
        $('.below-se').css('margin-top','-'+cookieheight+'px');
        $('.cookie-box-inner button').css({transition : 'all 0.3s ease-in-out'}); 
    }
});
$(window).on('resize scroll', function() {
    if(jQuery(window).width() > 991) {
        var cookieheight = $(".cookie-box").outerHeight();   
        $('.below-se').css('margin-top','-'+cookieheight+'px');
        $('.cookie-box-inner button').css({transition : 'all 0.3s ease-in-out'}); 
    }
});


/*!
 * parallax.js v1.4.2 (http://pixelcog.github.io/parallax.js/)
 * @copyright 2016 PixelCog, Inc.
 * @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
 */

;(function ( $, window, document, undefined ) {

  // Polyfill for requestAnimationFrame
  // via: https://gist.github.com/paulirish/1579671

  (function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
        || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function(callback) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function() { callback(currTime + timeToCall); },
          timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };

    if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function(id) {
        clearTimeout(id);
      };
  }());


  // Parallax Constructor

  function Parallax(element, options) {
    var self = this;

    if (typeof options == 'object') {
      delete options.refresh;
      delete options.render;
      $.extend(this, options);
    }

    this.$element = $(element);

    if (!this.imageSrc && this.$element.is('img')) {
      this.imageSrc = this.$element.attr('src');
    }

    var positions = (this.position + '').toLowerCase().match(/\S+/g) || [];

    if (positions.length < 1) {
      positions.push('center');
    }
    if (positions.length == 1) {
      positions.push(positions[0]);
    }

    if (positions[0] == 'top' || positions[0] == 'bottom' || positions[1] == 'left' || positions[1] == 'right') {
      positions = [positions[1], positions[0]];
    }

    if (this.positionX != undefined) positions[0] = this.positionX.toLowerCase();
    if (this.positionY != undefined) positions[1] = this.positionY.toLowerCase();

    self.positionX = positions[0];
    self.positionY = positions[1];

    if (this.positionX != 'left' && this.positionX != 'right') {
      if (isNaN(parseInt(this.positionX))) {
        this.positionX = 'center';
      } else {
        this.positionX = parseInt(this.positionX);
      }
    }

    if (this.positionY != 'top' && this.positionY != 'bottom') {
      if (isNaN(parseInt(this.positionY))) {
        this.positionY = 'center';
      } else {
        this.positionY = parseInt(this.positionY);
      }
    }

    this.position =
      this.positionX + (isNaN(this.positionX)? '' : 'px') + ' ' +
      this.positionY + (isNaN(this.positionY)? '' : 'px');

    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      if (this.imageSrc && this.iosFix && !this.$element.is('img')) {
        this.$element.css({
          backgroundImage: 'url(' + this.imageSrc + ')',
          backgroundSize: 'cover',
          backgroundPosition: this.position
        });
      }
      return this;
    }

    if (navigator.userAgent.match(/(Android)/)) {
      if (this.imageSrc && this.androidFix && !this.$element.is('img')) {
        this.$element.css({
          backgroundImage: 'url(' + this.imageSrc + ')',
          backgroundSize: 'cover',
          backgroundPosition: this.position
        });
      }
      return this;
    }

    this.$mirror = $('<div />').prependTo('body');

    var slider = this.$element.find('>.parallax-slider');
    var sliderExisted = false;

    if (slider.length == 0)
      this.$slider = $('<img />').prependTo(this.$mirror);
    else {
      this.$slider = slider.prependTo(this.$mirror)
      sliderExisted = true;
    }

    this.$mirror.addClass('parallax-mirror').css({
      visibility: 'hidden',
      zIndex: this.zIndex,
      position: 'fixed',
      top: 0,
      left: 0,
      overflow: 'hidden'
    });

    this.$slider.addClass('parallax-slider').one('load', function() {
      if (!self.naturalHeight || !self.naturalWidth) {
        self.naturalHeight = this.naturalHeight || this.height || 1;
        self.naturalWidth  = this.naturalWidth  || this.width  || 1;
      }
      self.aspectRatio = self.naturalWidth / self.naturalHeight;

      Parallax.isSetup || Parallax.setup();
      Parallax.sliders.push(self);
      Parallax.isFresh = false;
      Parallax.requestRender();
    });

    if (!sliderExisted)
      this.$slider[0].src = this.imageSrc;

    if (this.naturalHeight && this.naturalWidth || this.$slider[0].complete || slider.length > 0) {
      this.$slider.trigger('load');
    }

  };


  // Parallax Instance Methods

  $.extend(Parallax.prototype, {
    speed:    0.2,
    bleed:    0,
    zIndex:   -100,
    iosFix:   true,
    androidFix: true,
    position: 'center',
    overScrollFix: false,

    refresh: function() {
      this.boxWidth        = this.$element.outerWidth();
      this.boxHeight       = this.$element.outerHeight() + this.bleed * 2;
      this.boxOffsetTop    = this.$element.offset().top - this.bleed;
      this.boxOffsetLeft   = this.$element.offset().left;
      this.boxOffsetBottom = this.boxOffsetTop + this.boxHeight;

      var winHeight = Parallax.winHeight;
      var docHeight = Parallax.docHeight;
      var maxOffset = Math.min(this.boxOffsetTop, docHeight - winHeight);
      var minOffset = Math.max(this.boxOffsetTop + this.boxHeight - winHeight, 0);
      var imageHeightMin = this.boxHeight + (maxOffset - minOffset) * (1 - this.speed) | 0;
      var imageOffsetMin = (this.boxOffsetTop - maxOffset) * (1 - this.speed) | 0;

      if (imageHeightMin * this.aspectRatio >= this.boxWidth) {
        this.imageWidth    = imageHeightMin * this.aspectRatio | 0;
        this.imageHeight   = imageHeightMin;
        this.offsetBaseTop = imageOffsetMin;

        var margin = this.imageWidth - this.boxWidth;

        if (this.positionX == 'left') {
          this.offsetLeft = 0;
        } else if (this.positionX == 'right') {
          this.offsetLeft = - margin;
        } else if (!isNaN(this.positionX)) {
          this.offsetLeft = Math.max(this.positionX, - margin);
        } else {
          this.offsetLeft = - margin / 2 | 0;
        }
      } else {
        this.imageWidth    = this.boxWidth;
        this.imageHeight   = this.boxWidth / this.aspectRatio | 0;
        this.offsetLeft    = 0;

        var margin = this.imageHeight - imageHeightMin;

        if (this.positionY == 'top') {
          this.offsetBaseTop = imageOffsetMin;
        } else if (this.positionY == 'bottom') {
          this.offsetBaseTop = imageOffsetMin - margin;
        } else if (!isNaN(this.positionY)) {
          this.offsetBaseTop = imageOffsetMin + Math.max(this.positionY, - margin);
        } else {
          this.offsetBaseTop = imageOffsetMin - margin / 2 | 0;
        }
      }
    },

    render: function() {
      var scrollTop    = Parallax.scrollTop;
      var scrollLeft   = Parallax.scrollLeft;
      var overScroll   = this.overScrollFix ? Parallax.overScroll : 0;
      var scrollBottom = scrollTop + Parallax.winHeight;

      if (this.boxOffsetBottom > scrollTop && this.boxOffsetTop <= scrollBottom) {
        this.visibility = 'visible';
        this.mirrorTop = this.boxOffsetTop  - scrollTop;
        this.mirrorLeft = this.boxOffsetLeft - scrollLeft;
        this.offsetTop = this.offsetBaseTop - this.mirrorTop * (1 - this.speed);
      } else {
        this.visibility = 'hidden';
      }

      this.$mirror.css({
        transform: 'translate3d(0px, 0px, 0px)',
        visibility: this.visibility,
        top: this.mirrorTop - overScroll,
        left: this.mirrorLeft,
        height: this.boxHeight,
        width: this.boxWidth
      });

      this.$slider.css({
        transform: 'translate3d(0px, 0px, 0px)',
        position: 'absolute',
        top: this.offsetTop,
        left: this.offsetLeft,
        height: this.imageHeight,
        width: this.imageWidth,
        maxWidth: 'none'
      });
    }
  });


  // Parallax Static Methods

  $.extend(Parallax, {
    scrollTop:    0,
    scrollLeft:   0,
    winHeight:    0,
    winWidth:     0,
    docHeight:    1 << 30,
    docWidth:     1 << 30,
    sliders:      [],
    isReady:      false,
    isFresh:      false,
    isBusy:       false,

    setup: function() {
      if (this.isReady) return;

      var $doc = $(document), $win = $(window);

      var loadDimensions = function() {
        Parallax.winHeight = $win.height();
        Parallax.winWidth  = $win.width();
        Parallax.docHeight = $doc.height();
        Parallax.docWidth  = $doc.width();
      };

      var loadScrollPosition = function() {
        var winScrollTop  = $win.scrollTop();
        var scrollTopMax  = Parallax.docHeight - Parallax.winHeight;
        var scrollLeftMax = Parallax.docWidth  - Parallax.winWidth;
        Parallax.scrollTop  = Math.max(0, Math.min(scrollTopMax,  winScrollTop));
        Parallax.scrollLeft = Math.max(0, Math.min(scrollLeftMax, $win.scrollLeft()));
        Parallax.overScroll = Math.max(winScrollTop - scrollTopMax, Math.min(winScrollTop, 0));
      };

      $win.on('resize.px.parallax load.px.parallax', function() {
          loadDimensions();
          Parallax.isFresh = false;
          Parallax.requestRender();
        })
        .on('scroll.px.parallax load.px.parallax', function() {
          loadScrollPosition();
          Parallax.requestRender();
        });

      loadDimensions();
      loadScrollPosition();

      this.isReady = true;
    },

    configure: function(options) {
      if (typeof options == 'object') {
        delete options.refresh;
        delete options.render;
        $.extend(this.prototype, options);
      }
    },

    refresh: function() {
      $.each(this.sliders, function(){ this.refresh() });
      this.isFresh = true;
    },

    render: function() {
      this.isFresh || this.refresh();
      $.each(this.sliders, function(){ this.render() });
    },

    requestRender: function() {
      var self = this;

      if (!this.isBusy) {
        this.isBusy = true;
        window.requestAnimationFrame(function() {
          self.render();
          self.isBusy = false;
        });
      }
    },
    destroy: function(el){
      var i,
          parallaxElement = $(el).data('px.parallax');
      parallaxElement.$mirror.remove();
      for(i=0; i < this.sliders.length; i+=1){
        if(this.sliders[i] == parallaxElement){
          this.sliders.splice(i, 1);
        }
      }
      $(el).data('px.parallax', false);
      if(this.sliders.length === 0){
        $(window).off('scroll.px.parallax resize.px.parallax load.px.parallax');
        this.isReady = false;
        Parallax.isSetup = false;
      }
    }
  });


  // Parallax Plugin Definition

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var options = typeof option == 'object' && option;

      if (this == window || this == document || $this.is('body')) {
        Parallax.configure(options);
      }
      else if (!$this.data('px.parallax')) {
        options = $.extend({}, $this.data(), options);
        $this.data('px.parallax', new Parallax(this, options));
      }
      else if (typeof option == 'object')
      {
        $.extend($this.data('px.parallax'), options);
      }
      if (typeof option == 'string') {
        if(option == 'destroy'){
            Parallax['destroy'](this);
        }else{
          Parallax[option]();
        }
      }
    })
  };

  var old = $.fn.parallax;

  $.fn.parallax             = Plugin;
  $.fn.parallax.Constructor = Parallax;


  // Parallax No Conflict

  $.fn.parallax.noConflict = function () {
    $.fn.parallax = old;
    return this;
  };


  // Parallax Data-API

  $(document).on('ready.px.parallax.data-api', function () {
    $('[data-parallax="scroll"]').parallax();
  });
  
  

    $(document).on('click', '.swatch label', function( ) {
        let clickedText = $(this).closest('div').find('.variation-name').text().replace(/ /g,'').toLowerCase();
        $(document).find('#product-select').find('option').each(function() {
            let optionText = $(this).text().replace(/ /g,'').toLowerCase();
            if( clickedText == optionText ) {
                $(this).attr('selected', 'selected' ); 
            } else {
                $(this).attr('selected', false );
            }
        } );


        getProductTotal( $(this) );
    });

    $(document).on('ready', function() {
        populateProductTotalVariation();
    });

    $(document).on('click', '.adjust', function() {
        populateProductTotalVariation();
    });

    function populateProductTotalVariation() {
        let selectedVariation = $(document).find('#product-select').find('option[selected="selected"]').text().replace(/ /g,'').toLowerCase();
        $(document).find('.variation-name').each(function() {
            let matchedVariation = $(this).text().replace(/ /g,'').toLowerCase();
            console.log(matchedVariation );
            if( matchedVariation == selectedVariation ) {
                let selectedVariationPrice = parseFloat( $(this).closest('div').find('.variation-price').text().replace('$', '') );
                let quantity = parseInt( $(document).find('.item-quantity').val() ); 
                let gTotal = selectedVariationPrice*quantity;
                populateGTotal( gTotal ); 
            }
        });
    }

    function getProductTotal( elem ) {
        let selectedVariationPrice = parseFloat( elem.closest('div').find('.variation-price').text().replace('$', ''));
        let quantity = parseInt( $(document).find('.item-quantity').val() ); 
        let gTotal = selectedVariationPrice*quantity;
        populateGTotal( gTotal ); 
    }

    function populateGTotal( total ) {
        $(document).find('.total-price').text( '$' + total + '.00' );
    }
  
//   console.log($('.appstle_stand_alone_selector').length);

}(jQuery, window, document));


// VARIANT SCROLL
$(document).ready(function(){
  $('.lemon').on('click',function(){
    $('.pdp-slider').slick('slickGoTo', 0);
  });
  $('.sugar').on('click',function(){
    $('.pdp-slider').slick('slickGoTo', 1);
  });
  $('.spice').on('click',function(){
    $('.pdp-slider').slick('slickGoTo', 4);
  });
  $('.sugared-ginger').on('click',function(){
    $('.pdp-slider').slick('slickGoTo', 5);
  });
  $('.butter-rum').on('click',function(){
    $('.pdp-slider').slick('slickGoTo', 6);
  });
  $('.orange-brandy').on('click',function(){
    $('.pdp-slider').slick('slickGoTo', 7);
  });
});

